import produce from 'immer';

const INITIAL_STATE = {
  loading: false,
};

export default function mra(state = INITIAL_STATE, action) {
  return produce(state, draft => {
    switch (action.type) {
      case '@mra/SAVE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mra/SAVE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mra/SAVE_FAILURE': {
        draft.loading = false;
        break;
      }
      case '@mra/UPDATE_REQUEST': {
        draft.loading = true;
        break;
      }
      case '@mra/UPDATE_SUCCESS': {
        draft.loading = false;
        break;
      }
      case '@mra/UPDATE_FAILURE': {
        draft.loading = false;
        break;
      }
      default:
    }
  });
}